import AcademicDatesRepository from '../../domain/repositories/AcademicDatesRepository';
import AcademicDatesDataStoreFactory from '../factories/AcademicDatesDataStoreFactory';
import AcademicDatesDataStore from '../datastores/AcademicDatesDataStore';

export default class AcademicDatesDataRepository
  implements AcademicDatesRepository
{
  getAcademicDates(period: string) {
    const academicDatesDataStore: AcademicDatesDataStore =
      AcademicDatesDataStoreFactory.create();
    return academicDatesDataStore.getAcademicDates(period);
  }
}
